(function () {
    'use strict';

    angular
        .module('app')
        .controller('TaskListCtrl', TaskListCtrl);

    TaskListCtrl.$inject = ['WindowTitleService'];
    
    function TaskListCtrl(WindowTitleService) {
        /* jshint validthis:true */
        var vm = this;

        activate();

        function activate() {
            WindowTitleService.setTitle('Tasks');
        }
    }
})();
